const DefaultConfig = {
    androidProvider: 'capacitorAdmob', //cordovaAdmob or capacitorAdmob
    admobAppId_Android: 'ca-app-pub-2191584882036728~1736221292'
    , admobInterstitialAdId_Android: 'ca-app-pub-2191584882036728/8928331511'
    , admobRewardedAdId_Android: 'ca-app-pub-2191584882036728/2529593672'
    , admobAppOpenAdId_Android: 'ca-app-pub-2191584882036728/9040868616'
    , admobAppId_iOS: 'ca-app-pub-2191584882036728~3372752502'
    , admobInterstitialAdId_iOS: 'ca-app-pub-2191584882036728/9363445781'
    , admobRewardedAdId_iOS: 'ca-app-pub-2191584882036728/6394130144'
    , admobAppOpenAdId_iOS: 'ca-app-pub-2191584882036728/6295285774'
    , admobid_windows: ''
    , facebookAdId_interstital: "1264960130273679_1303003049802720" //First Instant Games Interstitial Placement
    , facebookAdId_reward: "1264960130273679_2065661693536848"
    , googleH5_ad_client: "ca-pub-2191584882036728"
    , googleH5_ad_channel: "4286624596"
    , offsetStartdelay: 300  //start with 1 min passed to get the first ad to show faster
    , delayBetweenAds: 360  //check for  360 (6 min) seconds passed was 180
    , delayBetweenRewardedAds: 600  //check for  600 seconds passed 
    , awayResetTime: 1200  //check if over 20 min, may have not been in the app and reopened it with out restarting 

};
export default DefaultConfig;
